"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = require("./styled-components");
var _offerTitle = _interopRequireDefault(require("../offer-title/offer-title"));
var _cardList = _interopRequireDefault(require("../card-list/card-list"));
var Product = function Product(_ref) {
  var titleDetails = _ref.titleDetails,
    offerItems = _ref.offerItems,
    counterMessage = _ref.counterMessage;
  return /*#__PURE__*/_react.default.createElement(_styledComponents.ProductContainer, {
    size: {
      '@initial': 'mobile',
      '@tablet': 'tablet',
      '@desktop': 'desktop'
    }
  }, /*#__PURE__*/_react.default.createElement(_offerTitle.default, Object.assign({}, titleDetails, {
    counterMessage: counterMessage
  })), /*#__PURE__*/_react.default.createElement(_cardList.default, {
    items: offerItems
  }));
};
Product.propTypes = {
  titleDetails: _propTypes.default.shape({
    amount: _propTypes.default.string,
    title: _propTypes.default.string,
    bank: _propTypes.default.string,
    plan: _propTypes.default.shape({
      title: _propTypes.default.string,
      subTitle: _propTypes.default.string,
      superScript: _propTypes.default.string
    }),
    subTitle: _propTypes.default.string,
    expiryDate: _propTypes.default.string,
    noOfDaysToExpiry: _propTypes.default.number
  }).isRequired,
  offerItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string,
    content: _propTypes.default.element
  })).isRequired,
  counterMessage: _propTypes.default.string
};
Product.defaultProps = {
  counterMessage: ''
};
var _default = exports.default = Product;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/@pf-loan-funnel/pf-confirm-apply/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');